import { MessageCircle, Phone, Mail, Instagram } from "lucide-react";
import { CONTACT } from "../data/content";
import Logo from "./Logo";

const SOCIALS = [
  { icon: MessageCircle, href: CONTACT.whatsapp, label: "WhatsApp", testid: "footer-whatsapp-link" },
  { icon: Phone, href: CONTACT.phoneHref, label: "Call", testid: "footer-phone-link" },
  { icon: Mail, href: CONTACT.emailHref, label: "Email", testid: "footer-email-link" },
  { icon: Instagram, href: CONTACT.instagram, label: "Instagram", testid: "footer-instagram-link" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="bg-prussian text-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-8">
      <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
        <div className="md:col-span-5">
          <div className="mb-5">
            <Logo light />
          </div>
          <p className="text-sm text-blueprint-line/80 leading-relaxed max-w-sm">
            Cost-effective, structurally strong construction across Telangana since
            2007. Homes, commercial spaces and turnkey projects — engineered to outlast.
          </p>
          <p className="mt-4 font-mono text-[9px] tracking-[0.3em] uppercase text-blueprint-line/60">
            Civil Contractors · Builders · Realtors
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-blueprint-line/60 mb-5">Reach Us</p>
          <p className="text-sm text-blueprint-line/90 leading-relaxed">{CONTACT.address}</p>
          <p className="mt-3 text-sm text-blueprint-line/90">{CONTACT.phoneDisplay}</p>
          <p className="text-sm text-blueprint-line/90">{CONTACT.email}</p>
          <p className="mt-3 font-mono text-[9px] tracking-[0.25em] uppercase text-blueprint-line/60">
            J. Ramanjaneyulu — Proprietor
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-blueprint-line/60 mb-5">Connect</p>
          <div className="flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={s.testid}
                className="w-11 h-11 border border-white/20 flex items-center justify-center text-blueprint-line hover:bg-blueprint-accent hover:border-blueprint-accent hover:text-white transition-colors duration-300"
              >
                <s.icon size={17} strokeWidth={1.75} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <p
        data-testid="footer-wordmark"
        className="font-display font-extrabold tracking-tight text-outline leading-none text-[15.5vw] whitespace-nowrap select-none text-center mt-10 -mb-4"
        aria-hidden
      >
        SAI MOHAN
      </p>

      <div className="relative flex flex-wrap items-center justify-between gap-3 pt-6 border-t border-white/10">
        <p className="font-mono text-[9px] md:text-[10px] tracking-[0.25em] uppercase text-blueprint-line/60">
          © 2026 Sai Mohan Constructions
        </p>
        <p className="font-mono text-[9px] md:text-[10px] tracking-[0.25em] uppercase text-blueprint-line/60">
          www.SaiMohanConstructions.com
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
